import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import { en, tr } from "vuetify/lib/locale";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { en, tr },
    current: "tr",
  },
});
